/**
 * TicketThread — a support ticket's conversation, oldest first. Member messages sit left, Support
 * replies sit right in gold. `viewer` decides the labels: a member sees "You" / "Support", an admin
 * sees the member's username and which admin replied.
 */
const formatWhen = (iso) => (iso ? String(iso).replace('T', ' ').slice(0, 16) : '');

const TicketThread = ({ messages, viewer = 'member', memberName }) => (
  <ol className="space-y-3" data-testid="ticket-thread">
    {(messages || []).map((m, i) => {
      const fromAdmin = m.sender_role === 'admin';
      const who = fromAdmin
        ? viewer === 'admin' && m.sender_username
          ? `Support · ${m.sender_username}`
          : 'Support'
        : viewer === 'member'
          ? 'You'
          : m.sender_username || memberName || 'Member';
      return (
        <li
          // Messages are append-only and have no id, so the index is a stable key.
          key={i}
          className={`flex ${fromAdmin ? 'justify-end' : 'justify-start'}`}
          data-testid={`ticket-message-${i}`}
        >
          <div
            className="max-w-[85%] rounded-xl border p-3"
            style={
              fromAdmin
                ? { background: 'rgba(255,182,18,0.06)', borderColor: 'rgba(255,182,18,0.30)' }
                : { background: 'rgba(0,0,0,0.42)', borderColor: 'rgba(255,255,255,0.10)' }
            }
          >
            <div className="flex items-center gap-2 mb-1 text-[10px] uppercase tracking-[0.18em]">
              <span style={{ color: fromAdmin ? '#FFC20E' : 'var(--sc-text-mute)' }}>{who}</span>
              <span className="text-[var(--sc-text-mute)] normal-case tracking-normal">{formatWhen(m.created_at)}</span>
            </div>
            <p className="text-[13px] text-[var(--sc-text)] whitespace-pre-wrap leading-relaxed">{m.body}</p>
          </div>
        </li>
      );
    })}
  </ol>
);

export default TicketThread;
